import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import paperReducer from '../features/papers/paperSlice';
import commentReducer from '../features/comments/commentSlice';
import bookmarkReducer from './slices/bookmarkSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    papers: paperReducer,
    comments: commentReducer,
    bookmarks: bookmarkReducer
  },
});

export default store; 